'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('./colors');

var _fonts = require('./fonts');

var common = {
  brandPalette: _colors.brandPalette,
  grayPalette: _colors.grayPalette,
  nodePalette: _colors.nodePalette,
  primaryFontFamily: _fonts.primaryFontFamily,
  secondaryFontFamily: _fonts.secondaryFontFamily,
  typography: _fonts.typography
};
exports.default = common;